import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "update-group-modal",
  props: ["title", "value", "user", "from"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      groups: [],
      data: {
        group: null
      },
      rules: {
        group: {
          type: "integer",
          required: true
        }
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      if (this.user) {
        this.data.group = this.user.group.id || 0;
      }
      Axios.get("users/groups/").then(function (resp) {
        _this.groups = resp.data.groups;
        _this.groups.unshift({
          id: 0,
          name: '无'
        });
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;
      var data = {
        group: this.data.group
      };
      this.loading = true;
      if (this.from !== 'active') {
        return Axios.put("users/".concat(this.user.id, "/group/"), data).then(function () {
          return _this2.loading = false;
        }, function (e) {
          _this2.loading = false;
          throw e;
        });
      }
      return Axios.post("users/".concat(this.user.id, "/activate/"), data).then(function () {
        return _this2.loading = false;
      }, function (e) {
        _this2.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    }
  }
};